module.exports = "/assets/bc10dcf23a1336e4a39a0e5055fb4e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WF.png
// module id = 1958
// module chunks = 0